export default {
  'ja-jp': {
    flag: '日本語',
    shopManagement: '施設管理者',
    estimatedPaymentAmount: 'お支払い予想金額',
    common: {
      search: '検索',
    },
    footer: {
      address: 'Ergosleep Building 3F, Nonhyeon-ro 721 Gangnam-gu, Seoul, Korea',
      customerService: 'Customer Service 822-1577-0564',
      companyNameKorean: 'B1SOFT CO.,LTD',
      companyCeoName: 'CEO: Choi Seok Woong',
      businessLicenseNumberText: 'Business License Number',
      businessLicenseNumber: '816-87-01138',
      companyNameEnglish: 'B1SOFT., LTD B1SOFT',
    },
    currency: {
      kr: {
        text: 'KRW',
        symbol: '₩',
      },
      us: {
        text: 'USD',
        symbol: '$',
      },
    },
    grade: {
      Rookie: 'ルーキー',
      Beginner: 'ビギナー',
      Amateur: 'アマチュア',
      SemiPro: 'セミプロ',
      Pro: 'プロ',
      TourPro: 'ツアープロ',
      Challenger: 'チャレンジャー',
    },
    gender: {
      man: '男性',
      woman: '女性',
      unLimit: '制限なし',
    },
    menu: {
      shopInfoManagement: '店舗情報管理',
      gameRoundOptionOptionManagement: 'ゲームオプション管理',
      drivingRangeOptionOptionManagement: '練習場のオプション管理',
      realtimeControlOptionManagement: 'リアルタイムオプション管理',
      agreement: '利用規約',
      signOut: 'ログアウト',
    },
    signIn: {
      id: 'ID',
      password: 'パスワード',
      forgotId: 'IDを忘れた場合',
      forgotPassword: 'パスワードを忘れた場合',
      rememberMe: 'ログイン状態維持',
      buttonSignIn: 'ログイン',
      cookie: 'クッキー 削除',
      cookieMessage: 'クッキーを削除しました。',

      fail: 'ログインに失敗しました。もう一度お試しください。',
    },
    notification: {
      title: 'お知らせ',
      no: '番号',
      roomName: '部屋の名前',
      callTime: '呼び出し時間',
      message: 'メッセージ',
      confirm: '確認',
      noNotificationMSG: '通知メッセージが呼び出されません。',

      billing_automatic_payment_failed: '[K-Golf 自動決済失敗のお知らせ] K-Golfの自動決済が失敗しました。${payment_date}以降、練習場以外のコンテンツが利用できなくなります。未払い分の決済やその他のご質問についてはカスタマーサポートにお問い合わせください。[カスタマーサポート] ${customer_center_number}',
      billing_automatic_payment_guide: '[K-Golf 自動決済のご案内] K-Golfの自動決済が${payment_date}に予定されています。口座の状態をご確認ください。自動決済が完了しない場合、決済日以降は練習場以外のコンテンツが利用できなくなります。[カスタマーサポート] ${customer_center_number}',
      billing_automatic_payment_success: '[K-Golf 決済完了のお知らせ] K-Golfの自動決済が完了しました。',
      billing_content_restrictions_notice: '[K-Golf 利用制限のお知らせ] 決済が完了していないため、${payment_date}以降は練習場以外のコンテンツが利用できなくなります。未払い分の決済やその他のご質問についてはカスタマーサポートにお問い合わせください。[カスタマーサポート] ${customer_center_number}',
      billing_manual_payment_guide: '[K-Golf 一般決済期間のお知らせ] 決済期間は${start_date}から${end_date}までです（${diff_day}日間）。この期間内に決済が完了しない場合、決済日以降は練習場以外のコンテンツが利用できなくなります。[カスタマーサポート] ${customer_center_number}',

      game_client_additional_access_game_round_approval_failed: '${client_name}のラウンド追加利用の承認に失敗しました。',
      game_client_additional_access_game_round_request: '${client_name}がラウンド追加利用をリクエストしました。',
      game_client_additional_access_game_round_request_reject: '${client_name}のラウンド追加利用のリクエストが拒否されました。',

      game_client_cancel_shot_failed: '${client_name}の最後のショットのキャンセルに失敗しました。',
      game_client_cancel_shot_failed_2: 'プレイヤーのショットキャンセル回数がすべて使用されました。',
      game_client_cancel_shot_failed_3: 'ゲーム進行中のため、ショットキャンセルに失敗しました。',
      game_client_cancel_shot_failed_4: 'キャンセルできるショットがありません。',
      game_client_cancel_shot_success: '${client_name}の最後のショットをキャンセルしました。',

      game_client_extended_wait_success: '${client_name}が待機状態に設定されました。',

      game_client_force_disconnection_failed: '${client_name}の強制接続解除に失敗しました。',
      game_client_force_disconnection_success: '${client_name}の強制接続解除が成功しました。',

      game_client_guest_login_failed: '${client_name}のゲストログインに失敗しました。',
      game_client_guest_login_success: '${client_name}のゲストログインが成功しました。',

      game_client_limit_change_failed: '${client_name}の制御オプション変更送信に失敗しました。',
      game_client_limit_change_success: '${client_name}の制御オプションが変更されました。',

      game_client_lock_failed: '${client_name}のロック指示に失敗しました。',
      game_client_lock_success: '${client_name}がロック状態に設定されました。',

      game_client_player_count_change_failed: '${client_name}のプレイヤー人数変更に失敗しました。',
      game_client_player_count_change_request_reject: '${client_name}からのプレイヤー人数変更のリクエストが拒否されました。',
      game_client_player_count_change_success: '${client_name}のプレイヤー人数が${n}人から${player_count}人に変更されました。',

      game_client_reset_mulligan_failed: '${client_name}のマリガン回数のリセットに失敗しました。',
      game_client_reset_mulligan_success: '${client_name}のマリガン回数がリセットされました。',

      game_client_shop_manager_call_request: '${client_name}が店舗マネージャーを呼び出しました。',

      game_client_time_extension_failed: '${client_name}の利用時間延長の指示に失敗しました。',
      game_client_time_extension_request: '${client_name}が利用時間延長をリクエストしました。',
      game_client_time_extension_request_reject: '${client_name}の利用時間延長リクエストが拒否されました。',
      game_client_time_extension_success_1: '${client_name}の利用時間が${add_time}分延長されました。',

      game_client_unlock_failed: '${client_name}のロック解除指示に失敗しました。',
      game_client_unlock_success: '${client_name}のロックが解除されました。',

      game_client_user_login_failed: '${client_name}のユーザーログインに失敗しました。',
      game_client_user_login_success: '${client_name}のユーザーログインが成功しました。',

      kms_notice: '${title}',

      quit_game_client_failed: '${client_name}の終了リクエストに失敗しました。',
      quit_game_client_success: '${client_name}の終了リクエストが成功しました。',

      run_game_client_failed: '${client_name}の開始リクエストに失敗しました。',
      run_game_client_success: '${client_name}の開始リクエストが成功しました。'
    },
    dashboard: {
      content: 'ダッシュボード',
    },
    gameHistory: {
      searchPeriod: '検索期間',
      userNickname: '会員ニックネーム',
      userNicknamePlaceholder: 'ニックネームを入力してください。',
      search: '検索',
      gameType: 'ゲーム種類',
      shopClient: '打席',
      all: '全体',
      gameHistoryStatistics: 'ゲーム結果の統計',
      gameHistoryStatisticsNoticeText: '( 検索結果基準の統計です。 )',
      gameMode: 'ゲームモード',
      normalGame: '一般ゲーム',
      drivingRange: '練習場',
      swingDiagnosis: 'スイング診断',
      userType: '会員区分',
      user: '会員',
      guest: 'ゲスト',
      gender: '性別',
      male: '男性',
      female: '女性',
      times: '回',
      gameRoundList: 'ゲームラウンドリスト',
      gameNumbers: 'ゲーム番号',
      clientName: '打席名',
      numberPlayers: 'プレイヤー数',
      numberHolesCompleted: '完了したホールの数',
      startDate: '開始時間',
      endDate: '終了時間',
      more: '更に表示',
      close: '閉じる',
      download: 'ダウンロード',
      alert: {
        message1: '打席を選択してください。',
        message2: 'ゲーム種類を選択してください。',
        message3: '期間は最大3ヶ月まで選択できます。',
        message4: '検索データ量によっては時間がかかる場合があります。\n続けますか？',
        message5: 'No data',
      },
    },
    clientStatus: {
      sendMessage: 'メッセージ転送',
      statusInfo: '状態',
      proceeding: '進行中',
      endUse: '利用終了',
      blind: 'ロック',
      lobby: 'ロビー',
      clientOff: 'クライアントオフ',
      course: 'Course',
      playerCount: 'プレイヤー数',
      remainingTime: '残り時間',
      start: 'スタート',
      paymentType: '支払い方法',
      usageModeSetting: 'モードの設定',
      gameType: 'ゲーム種類',
      usageTimeSetting: '利用時間の設定',
      holeType: 'ホールタイプ',
      drivingRangeTime: '練習時間',
      noLimit: '制限なし',
      stroke: 'ゲーム',
      drivingRange: '練習',
      minutes: '分',
      lessThanMinute: '1分未満',
      paymentProgress: '後払い中',
      peopleCount: '名',
      noDrivingRange: 'なし',
      status: '状態',
      usageTime: '利用時間',
      usageCourse: '利用コース',
      usagePeopleCount: '使用人数',
      addGuest: 'ゲストの追加',
      extendedTime: '時間延長',
      scorecard: 'スコアカード',
      changeSetting: '設定変更',
      resetMulligan: 'マリガン初期化',
      cancelShot: 'ショット解除',
      bilnd: 'ロック',
      currentHole: '現在ホール',
      sound : '通知音',
      clientType : '打石区分',
      popup: {
        close: '閉じる',
        addGuest: {
          addGuest: 'ゲストの追加',
          guestNicknamePlaceholder: 'ゲストのニックネームを入力してください。',
          cancel: 'キャンセル',
        },
        shotCancel: {
          confirmMessage: '「${clientName}」打席での最後のショットをキャンセルします。',
          shotCancel: '確認',
          cancel: 'キャンセル',
        },
        sendMessage: {
          sendMessage: 'メッセージ送信',
          all: 'ALL',
          cancel: 'キャンセル',
          messagePlaceholder: 'メッセージの内容を入力してください。',
        },
        extendedTime: {
          extendedTime: '時間延長',
          minutes: '分',
          addServiceTime: '利用時間の追加',
          cancel: 'キャンセル',
        },
        changeSetting: {
          changeSetting: '設定変更',
          cancel: 'キャンセル',
        },
      },
      alert: {
        message1: '支払い方法を選択してください。',
        message2: '利用時間を選択してください。',
        message3: '利用モードを選択してください。',
        message4: 'ゲーム種類を選択してください。',
        message5: 'ホールタイプを選択してください。',
        message6: 'プレイヤー数を選択してください。',
        message7: '練習時間を選択してください。',
        message8: '画面をロックしますか？',
        message9: 'しばらくしてからもう一度試してください。',
        message10: 'マリガンを初期化しますか？',
        message11: 'ラウンドID情報がないため、マリガンの初期化要請ができません。',
        message12: '打席制御設定を変更しますか?',
        message13: 'ラウンド設定を変更しますか？',
        message14: 'メッセージを送信先の打席を選択してください。',
        message15: 'メッセージを入力してください。',
        message16: '支払方法が後払いとなっているため時間延長ができません。',
        message17: '延長時間をもう一度選択してください。',
        message18: 'ゲストニックネームを入力してください。',
        message19: 'ログイン可能な人数に達してないためゲストのログインができません。',
        message20: 'ゲームラウンドID情報がないため、ショットキャンセルをリクエストできません。',
        
        message1000: 'ゲームラウンド設定変更は準備中です。',
      },
    },
    billing: {
      tossPay: {
        addressTitle: '配送先',
        clearAddressButton: '住所をクリア',
        clearAddressTooltip: '受取人/電話は保持し、住所のみ初期化',
        recipientPlaceholder: '受取人',
        phonePlaceholderKrw: '電話番号（例: 010-1234-5678）',
        phonePlaceholderIntl: '電話番号（国番号可）',
        postcode: '郵便番号',
        searchAddressButton: '住所検索',
        address1Krw: '基本住所',
        address2Krw: '詳細住所（棟/号室など）',
        address1Intl: '住所1',
        searchHint: '検索…',
        address2Intl: '住所2（Apt、部屋番号など）',
        country: '国',
        city: '市区町村',
        state: '都道府県 / 州 / 地域',
        postalIntl: '郵便番号 / ZIP',
        saveNoteKrw: '※ 決済時に配送先が保存されます。',
        saveNoteIntl: '※ 決済と一緒に配送先が保存されます。',
        fedexTitle: 'FedExアカウント',
        fedexPlaceholder: 'FedExアカウント番号を入力',
        fedexNote: '※ 着払い（コレクト）発送に必要です。',
        // ▼ 追加
        fedexHelpTitle: 'FedExアカウントをお持ちでない方へ',
        fedexHelpDesc: '以下のリンクから作成してください。',
        fedexGlobalLink: 'FedExアカウント作成（グローバル）',
        fedexUSLink: 'FedExアカウント作成（米国）',
        fedexGuideLink: 'FedExアカウントの作成方法（FAQ）',
        paymentMethodsTitle: 'お支払い方法',
        agreeRequired: '利用規約およびプライバシーポリシーに同意してください。',
        enterShipping: '配送先を入力してください。',
        enterFedex: 'FedExアカウントを入力してください。',
        payNow: '決済する',
        cardLabel: 'クレジットカード',
        paypalLabel: 'PayPal',
        alipayLabel: 'Alipay',
      }
      ,
      paymentInfo: {
        ownerDefaultInfo: '店舗管理者基本情報',
        shopName: '店舗名',
        shopOwnerName: '管理者名',
        shopAddress: '店舗住所',
        shopAddressChangeNoticeText: '店舗の住所を変更する場合には、FLJカスタマーセンターまでにお問い合わせください。',
        receiveBillInfoChange: '明細書情報変更',
        receiveBillInfoChangeNoticeText: '利用料金に関する明細書を受け取る。',
        shopOwnerMobilePhone: '店舗管理者の連絡先',
        editButton: '修正',
        mobileBill: 'モバイル明細書',
        mobileBillNoticeText: '毎月利用料金明細書は登録された店舗連絡先に発送されます。',
        sendButton: '発送',
        shipsFirstDayEveryMonth: '毎月1日に発送',
        mobileBillNoAuth: '認証されていません。 モバイル認証を行わないと、支払い関連明細書を受け取ることができません。',
        shopOwnerEmail: '店舗管理者メールアドレス',
        authenticateButton: '認証',
        emailBill: 'メール明細書',
        emailBillNoticeText: '毎月利用料金明細書は登録された店舗連絡先に発送されます。',
        emailBillNoAuth: '認証されていません。 メール認証を行わないと支払い明細書を受け取ることができません。',
      },
      recurringPayment: {
        noRecurringPaumentServiceNoticeText1: '定期決済サービスに登録されていない店舗です。',
        noRecurringPaumentServiceNoticeText2: '定期決済管理は、定期決済サービスに登録してから操作可能です。',
        agreementToUseRecurringPaymentService: '定期決済サービス利用の同意',
        guide: '定期決済サービス登録ガイド',
        whatIsRecurringPaymentService: '定期決済サービスとは?',
        recurringPaymentServiceDescription:
            '指定した毎月決済日に自動的に決済行われるサービスです。 定期決済サービスをご利用の場合、決済金額の2.0％が割引されます。',
        agreeTermsConditionsRecurringPayment: '定期決済利用約款の同意',
        allAgreement: '全体同意',
        required: '必須',
        termsOfRecurringPaymentService: '定期決済サービス利用約款の同意',
        personalInformationProvidedThirdParties: '個人情報の第三者提供への同意',
        entrustingHandlingOfPersonalInformation: '個人情報の委託に同意',
        useAgreementButtonText: '定期決済サービス利用約款の同意',
        useAgreementNoticeText: '定期支払いの利用約款に同意してください。',
        recurringPaymentService: '定期決済サービス',
        status: '状態',
        statusApplyingText: '申請中',
        statusUseText: '利用中',
        serviceStartDate: 'サービス開始日',
        automaticPaymentDueDate: '自動支払い予定日',
        discountRate: '割引率',
        recurringPaymentServiceCancel: '定期決済サービスのキャンセル',
        bankAccountRegistrationAndManagement: '銀行口座の登録と管理',
        bankAccount: '銀行口座',
        bankAccountNumber: '口座番号',
        bankAccountName: '口座名義',
        management: '管理',
        addBankAccount: '銀行口座の登録',
        deleteBankAccount: '銀行口座の削除',
        noBankAccountNoticeText: '登録された口座がありません。<br />右側の口座登録ボタンを押して口座登録を行ってください。',
        creditCardRegistrationAndManagement: 'クレジットカードの登録と管理',
        creditCard: 'クレジットカード',
        creditCardNumber: 'クレジットカード番号',
        noCreditCardNoticeText: '登録されたカードがありません。<br />右側のカード登録ボタンを押してカードを登録を行ってください。',
        addCreditCard: 'クレジットカードの登録',
        deleteCreditCard: 'クレジットカードの削除',
        recurringPaymentNoticeText: '自動支払いサービスに口座とカード両方が登録されている場合は、<strong>口座を優先</strong>にお支払いされます。',
      },
      paymentProgress: {
        text1: 'お支払い情報を確認しています。',
        text2: 'しばらくお待ちください。',
      },
      paymentComplete: {
        text1: '決済完了',
        text2: '（仮想口座でのお支払いは、入金確認後にご利用いただけます)',
        buttonText: '完了',
      },
      paymentFail: {
        text1: '決済できませんでした。',
        text2: '',
        buttonText: '閉じる',
      },
      paymentCancel: {
        text1: '決済のキャンセル',
        text2: '',
        buttonText: '閉じる',
      },
      payment: {
        generalPayment: '一般料金の払い',
        prepayment: '予定決済金額の前払い',
        paymentUnpaidCharges: '未払金の支払い',

        chargesText: '未払い金額は<span class="price">|charges|</span> <span style="font-size:26px;">|currency|</span> です。',
        checkPaymentHistory: '支払い内訳を確認してください。',
        billingMonth: '請求月',
        amountBePaid: '請求金額',
        details: '内訳詳細',
        choosePaymentMethod: '決済方法を選択してください。',
        realTimeAccountTransfer: '銀行口座への振込',
        creditCardPayment: 'クレジットカード決済',

        tab1: {
          text1: '一般料金の支払い時期、または',
          text2: '請求金額がありません。',
          text3: '一般料金の支払い可能な期間',
          text4: '一般料金の支払いは、毎月1日からK-Golf本社が指定した決済日までです。',
          text5: '支払い期限',
          text6: '一般料金の支払い期間',
          text7: '毎月',
          text8: '日',
        },
        tab2: {
          text1: '前払い可能な期間ではないかあるいは',
          text2: '請求金額がありません。',
          text3: '前払い期間',
          text4: '前払いは毎月1日からK-Golf本社が指定した決済日までです。',
          text5: '支払い期限',
          text6: '一般料金の支払い期限',
          text7: '毎月',
          text8: '日',
        },
        tab3: {
          text1: '未払い金額がありません。',
          text2: '未払い金額はK-Golf本社が指定した決済日以降から決済可能です。',
          text3: 'K-Golf決済日',
          text4: '毎月',
          text5: '日',
          text6: '前払い可能な期間',
          text7: '前払いは毎月1日からK-Golf本社が指定した決済日の前日まで決済可能です。',
          text8: '支払い期限',
          text9: '前払い可能な期間',
        },
      },
      bills: {
        monthPaymentAmount: '|month| 決済金額',
        usagePeriod: '利用期間',
        clientName: '打席名',
        usageAmount: '利用金額',
        discountAmount: '割引金額',
        paymentAmount: '支払い金額',
        contentPlan: 'コンテンツ',
        coursePlan: 'コース',
        minutes: '分',
        course: 'コース',
        totalCharges: '小計',
        count: '個',
        coutseUnlimit: '制限なし',
        vat: '税金',
        currentMonthTotalCharges: '今月の利用料金合計',
        totalAmount: '総請求利金額',
      },
      paymentHistory: {
        text1: '支払内訳は最大12ヶ月前までに照会可能です。',
        billMonth: '明細書の発行月',
        charges: '請求金額',
        paymentStatus: '支払い状況',
        paymentSuccess: '支払い完了',
        unpayment: '未払い',
      },
      itemPaymentHistory: {
        info01: '領収書は購入時に入力したメールアドレスから確認できます。',
        info02: '払い戻しはカスタマーセンターまでお問い合わせください。',
        date: '購入日',
        orderNumber: '注文番号',
        purchaseItem: '購入項目',
        charges: '決済金額',
        paymentMethod: '決済方法',
        materialCode: '材料コード',
        quantity:     '数量',
        paymentMethods: {
          CA:              'クレジットカード',
          AccountTransfer: '銀行振込',
          PZ:              'ペイジー',
          EASYPAY:         '簡易決済',
        },
        statuses: {
          0: '商品準備中',
          1: '発送完了',
          2: '配送完了',
          3: '返金',
        },
      },
    },
    customerService: {
      notice: {
        postType: '分類',
        searchPlaceholder: 'タイトル+内容',
        postTitle: 'タイトル',
        registrationDate: '登録日',
        attachments: '添付ファイル',
        moveListButtonText: 'リスト',
        postTypeCode: {
          notice: 'お知らせ',
          update: 'アップデート',
          event: 'イベント',
        },
      },
      qna: {
        test: 'test',
      },
    },
    edit: {
      shopInfoSetting: {
        clientTypeAlert: '打席タイプを選択してください。',

        shopInfo: '店舗情報',
        shopName: '店舗名',
        shopPhoneNumber: '店舗連絡先',
        shopAddress: '店舗住所',
        shopOwnerName: '店舗名義人名前',
        shopOwnerMobilePhone: '店舗名義人の連絡先',

        shopSalesInfo: '店舗営業情報',
        operatingTime: '営業時間',
        operatingTimePlaceholder: 'ex) \n平日AM 08:00〜PM:12:00 \n週末/祝日AM 06:00〜PM 12:00',
        screen: 'スクリーン',
        practiceRange: '練習場',
        lesson: 'レッスン',
        convenientFacilities: '便益施設',
        swingPlate: 'スイングプレート',
        leftHanded: '両手用打席',
        parking: '駐車場',
        equipmentStorage: '装備の保管',
        proLesson: 'プロレッスン',
        fee: '利用料金',
        feePlaceholder: '例）\n料金詳細についてはカウンター窓口にお問い合わせください。',
        storeView: '店舗全景',
        parkingNotice: '駐車場の案内',
        parkingPlaceholder: '例) \n無料駐車場（ビル駐車場を利用）',
        storeIntroduce: '店舗紹介',
        storeIntroducePlaceholder: 'ex) \n誰でも快適にゴルフを楽しむことができます。 \nご来店いただきありがとうございます。',
        clientList: '打席リスト',
        clientName: '打席名',
        clientOrder: '打席順番',
        clientInfo: '打席情報',
        clientType: '打席タイプ',
        cancel: 'キャンセル',
        saveChanges: '変更内容の保存',
      },
      shopGameRoundOptionSetting: {
        title: 'ゲーム設定管理',
        concede: 'コンシード',
        holecupPosition: 'ホールカップ位置',
        mulliganCount: 'マリガン数',
        swingPlate: 'スイングプレート',
        distanceUnit: '距離単位',
        greenPosition: 'グリーン位置',
        greenSpeed: 'グリーン速度',
        windStrength: '風の強さ',
        puttingLine: 'パッティングライン',
        bestVideo: 'スイング動画',
        continuePutting: 'パッティングの続き',
        caddyVoice: 'キャディー音声',
        noPuttMode: 'パットスキップ',
        obTeeAndHazardTee: 'OBティー、ハザードティー',
        on: 'オン',
        off: 'オフ',
        saveChanges: '変更内容の保存',
        shotInfoLocation: 'ショット位置情報',
        side: '側面',
        bottom: '下段',
        greenHardness: 'グリーン硬度',
        guideDistance: '目标距离',
        maxScoreFactor: 'ホール最大打水',
      },
      shopDrivingRangeOptionSetting: {
        title: '練習場の設定管理',
        course: 'コース',
        drivingRange1: 'KGOLF',
        drivingRange2: '張家諸',
        drivingRange3: 'セントーサセラポン',
        drivingRange4: 'ヒドゥンキャッスル',
        drivingRange5: 'KGOLF2',
        difficulty: '難易度',
        teeHeight: 'ティーの高さ',
        windStrength: '風の強さ',
        distanceUnit: '距離単位',
        swingPlate: 'スイングプレート',
        ballTrajectory: 'ボール軌道',
        fixedCamera: '固定カメラ',
        swingVideo: 'スイング動画',
        on: 'オン',
        off: 'オフ',
        saveChanges: '変更内容の保存',
      },
      shopClientRealTimeControlOptionSetting: {
        title: '打席リアルタイム制御オプションのデフォルト設定',
        paymentType: '決済方法',
        usageTimeSetting: '利用時間の設定',
        usageModeSetting: 'モードの設定',
        noLimit: '制限なし',
        stroke: 'ゲーム',
        drivingRange: '練習',
        usageContentSetting: '利用コンテンツの設定',
        availablePlayerCountSetting: '利用可能なプレーヤー人数の設定',
        holeType: 'ホールタイプ',
        drivingRangeTime: '練習時間',
        saveChanges: '変更内容の保存',
        peopleUnit: '名',
        none: 'なし',
        minutes: '分',
      },
      accountInfoSetting: {
        accountInfo: 'アカウント情報',
        name: '名前',
        id: 'ID',
        password: 'パスワード',
        changePassword: 'パスワード変更',
        newPasswordPlaceholder: '新しいパスワードを入力してください。',
        cancel: 'キャンセル',
        submit: '変更',
        validation: 'パスワードは数字、英語の小文字、英語の大文字を含めて4～12文字に設定できます。',
        successful: 'アカウントのパスワードが変更されました。',
        fail: 'パスワード変更に失敗しました。',
      },
      clientInfoSetting: {
        clientInfo: 'クライアントパスワードの変更',
        password: 'パスワード',
        changePassword: 'パスワード変更',
        newPasswordPlaceholder: '新しいパスワード（4桁の数字）を入力してください。',
        cancel: 'キャンセル',
        submit: '変更',
        validation: 'パスワードは4桁の数字のみ設定可能です。',
        successful: '店舗全体のクライアントのパスワードが変更されました。',
        fail: 'パスワード変更に失敗しました。',
      },

    },
    scorecard: {
      title: 'スコアカード',
      gameNumbers: 'ゲーム番号',
      gameType: 'ゲームタイプ',
      courseName: 'コース名',
      gameHoleType: 'ゲームホールタイプ',
      shopName: '店舗名',
      shopClientName: '打席名',
      startTime: '開始時間',
      endTime: '終了時間',
      concede: 'コンシード',
      holeCupPosition: 'ホールカップの位置',
      mulligan: 'マリガン',
      greenPosition: 'グリーン位置',
      greenSpeed: 'グリーン速度',
      swingPlate: 'スイングプレート',
      windStrength: '風の強さ',
      distanceUnit: '距離単位',
      puttingLine: 'パッティングライン',
      bestVideo: 'スイング動画',
      caddyVoice: 'キャディー音声',
      whetherUseObTeeAndHazardTee: 'OBティー、ハザードティーの使用',
      use: '使用',
      unused: '未使用',
      stroke: 'ストローク',
      newPerio: 'シンペリオ',
      ranking: 'ランキング',
      team: 'チーム',
      nickname: 'ニックネーム',
      handicap: 'ハンディキャップ',
      close: '閉じる',
      alertText1: '進行中のラウンドです。',
      grade: '等級',
      greenHardness: 'グリーン硬度',
      guideDistance: '目标距离',
      maxScoreFactor: 'ホール最大打水',
      on: 'オン',
      off: 'オフ',
    },
    alert: {
      comingSoon: '準備中.',
      unusualApproach: '異常なアプローチです。',
      deletePaymentMethodSuccess: '決済情報が削除されました。',
      deletePaymentMethodFail: '決済情報の削除ができませんでした。',
      shopRecurringPaymentCancelSuccess: '店舗の定期決済サービスが中止されました。',
      shopRecurringPaymentCancelFail: '店舗の定期決済サービスの中止が承認されませんでした。',
    },
    popup: {
      title: {
        sendMessage: 'メッセージの発送',
        scorecard: 'スコアカード',
        addGuest: 'ゲストの追加',
        shotCancel: 'ショット キャンセ',
        extendedTime: '時間延長',
        changeSetting: '設定変更',
        courseSelection: 'コース設定',
        rankingCriteriaGameRoundCount: 'ゲーム記録が多い順とは？',
        rankingCriteriaBackCount: 'バックカウント方式とは?',
        shopTournamentOpenConfirm: '大会開催の確認',
        shopTournamentModifyConfirm: '大会設定変更の確認',

        deleteTournamentConfirm: '予定大会の削除案内',
        earlyEndTournamentConfirm: '大会早期終了の案内',
        resetAwardsConfirm: '授賞初期化の案内',
        awardRecipientsSelectionConfirm: '受賞者選定の確認',
        tournamentAwardAnnouncementConfirm: '受賞者発表の確認',
        contentsItemPayment: 'コンテンツ適用の案内',
        callNotification: '呼び出し通知',
      },
      button: {
        close: '閉じる',
        cancel: 'キャンセル',
        confirm: '確認',
        announcement: '発表',
      },
    },
    agreement: {
      terms: '事業者利用規約',
      privacy: '個人情報処理方針',
      refund: '返金規定',
      termsText:
          'スクリーンゴルフシステムの開発会社であり製造会社であるケイゴルフと、ケイゴルフスクリーンゴルフシステムを用いて営利事業を運営する事業主（店舗主）との間におけるシステム利用に関する約款を以下のように定義します。\n\n' +
          '第1条（目的）\n' +
          '本約款（以下「約款」と称する）は、利用者が株式会社ケイゴルフ（以下「会社」と称する）が提供するサービス（スクリーンゴルフサービス）の利用およびインターネット関連サービス、Webおよびモバイルサービスの利用に関し、会社と事業主の権利、義務および責任事項、その他必要事項を定めることを目的とします。\n\n' +
          '第2条（用語の定義）\n' +
          '1.「事業主」とは、会社がサービスの提供を承認したケイゴルフ製品を設置し、店舗において営利を目的に事業を行う事業者代表を指します。\n' +
          '2.「ケイゴルフ店舗」（以下「事業場」とする）とは、事業主がケイゴルフの製品を購入し、会社がサービスの提供を承認したケイゴルフ製品設置店舗を指します。\n' +
          '3.「ケイゴルフ製品」とは、ケイゴルフが開発および製造したスクリーンゴルフシステムを指します。\n' +
          '4.「利用者顧客」とは、事業場を訪れケイゴルフ製品を利用し、事業場の料金ポリシーに従って利用料金を支払う顧客を指します。\n' +
          '5.「課金」とは、会社が開発したケイゴルフ製品のソフトウェアを用いてゲームや有料コンテンツを利用する際に発生する利用料に関する請求を意味します。\n' +
          '6.「ケイゴルフオンラインサービス」とは、利用者顧客が事業場を訪れケイゴルフ製品を使用して行うすべてのサービス（オンラインゴルフコース利用、ゲーム記録、イベントなど）を指します。\n' +
          '7.「ケイゴルフオンラインサービス利用料」とは、利用者顧客が「ケイゴルフオンラインゴルフコースサービス」を利用する際に支払う費用を指し、利用時に課金されます。\n' +
          '8.「店舗管理者」とは、会社が事業主に提供するケイゴルフ製品をオンラインで管理するためのコンピュータプログラムを指します。\n\n' +
          '第3条（ゲーム課金制の運用）\n' +
          '1.課金方式は以下の通りです。\n' +
          '  1) ケイゴルフオンラインゴルフコースサービスのコース利用料は、ゲームごとに事業主に課金されます。\n' +
          '  2) ゴルフコースモードでは、1ホールにつき100ウォンが基準となり、最大18ホールまで課金されます。\n' +
          '  3) 利用者顧客の都合または店舗運営上途中でゲームを中止した場合、使用ホール数に基づいて課金されます。\n' +
          '2.利用商品による課金は以下の通りです。\n' +
          '  1) 練習場C商品：9ホールの20コースのみ利用可能で、課金免除商品です。\n' +
          '  2) 結合型A・練習場B商品：すべてのコンテンツが利用可能で、コース利用時にはホール数×人数分の利用料が課金されます。\n' +
          '3.決済方法は以下の通りです。\n' +
          '  1) 決済は後払いの自動引落方式を原則とし、前払いおよび未納決済方式もあります。\n' +
          '  2) 事業主は月ごとの決済額を一括で支払う必要があり、分割納付はできません。\n' +
          '  3) 後払い自動引落：指定決済日に前月（1日～末日）の利用料を自動引落（午前／午後 計2回）。\n' +
          '  4) 前払い：指定決済日の2日前までに口座振込またはクレジットカード決済。\n' +
          '  5) 未納決済：指定日を過ぎた場合、事業主が直接決済。\n\n' +
          '第4条（決済方式・未収金処理・利用商品変更）\n' +
          '1.口座振込・クレジットカードの2種類。\n' +
          '2.未収金\n' +
          '  1) 決済日以降の未納金が発生した場合、即座にサービス停止。\n' +
          '  2) 未納発生日から毎日遅延利息が発生（0.n％）。\n' +
          '  3) 未納金決済完了後にサービス復旧。\n' +
          '3.利用商品変更は毎月1日に適用。\n\n' +
          '第5条（約款外の準則および関係法令との関係）\n' +
          '1.明示されていない事項については関係法令および慣習に従います。\n' +
          '2.電子商取引法などの消費者保護法令が優先適用されます。\n' +
          '3.個別約款がある場合、当該約款が優先されます。\n\n' +
          '第6条（免責条項）\n' +
          '1.天災地変・戦争・通信事業者のサービス中断等の不可抗力により発生した損害に対しては責任を負いません。\n' +
          '2.設備の保守・交換等に起因する損害に対しても責任を負いません。\n' +
          '3.事業主側のコンピュータエラー・不正確な情報入力等による損害に対して責任を負いません。\n' +
          '4.期待収益の不足や資料の利用による損害に対して責任を負いません。\n' +
          '5.掲示物の内容に対する事前審査義務はありません。\n' +
          '6.無料サービスに関しては、個人情報保護方針に違反した場合を除き責任を負いません。\n\n' +
          '第7条（契約解除など）\n' +
          '1.合意解除・売買の場合、事前通知および未納金の精算後にサービスを回収します。\n' +
          '2.遅延時は法定利率に基づき遅延利息を課します。\n' +
          '3.一部利用があった場合、相当金額および費用の請求が可能です。\n\n' +
          '第8条（紛争解決）\n' +
          '1.被害補償処理部署を運営します。\n' +
          '2.苦情・要望は優先的に処理し、遅延する場合は理由およびスケジュールを通知します。\n\n' +
          '第9条（準拠法・管轄裁判所）\n' +
          '1.大韓民国の法を準拠とします。\n' +
          '2.民事訴訟法上の管轄裁判所に提起します。',

      privacyText:
          '第1条 総則\n' +
          '株式会社Kゴルフ（以下「当社」）は、利用者が当社の店舗管理者（https://kms.thekgolf.com）で提供されるすべてのサービスを利用する際に提供する個人情報を大切に取り扱います。関連法令（通信秘密保護法、情報通信網法など）を遵守し、個人情報保護方針を通じて収集および利用の方法を分かりやすく案内します。本方針は法令および社内方針の変更により改定される場合があります。\n\n' +
          '第2条 個人情報の収集項目・方法および利用目的\n' +
          '（a）収集項目\n' +
          '  1）会員登録・サービス提供：氏名、ID、携帯電話、住所、メールアドレス（退会時削除）\n' +
          '  2）口座決済：銀行名、口座番号、預金者名（5年間）\n' +
          '  3）仮想口座：銀行名、入金者名（5年間）\n' +
          '  4）クレジットカード決済：カード会社、カード番号、有効期限（5年間）\n' +
          '  5）取引情報：IP、クッキー、接続ログ、利用記録（退会時削除）\n' +
          '  6）イベント・配送：氏名、住所、電話番号（目的達成後廃棄）\n' +
          '  7）販促物：氏名、住所、電話番号（目的達成後廃棄）\n\n' +
          '（b）利用目的\n' +
          '  1）契約履行・料金精算\n' +
          '  2）会員管理・本人確認・不正利用防止・苦情対応\n' +
          '  3）新サービス開発・マーケティング・統計・広告\n' +
          '  4）サービス障害時の個別通知\n\n' +
          '（c）保有期間\n' +
          '  - サービス利用期間中保有、退会・削除要求時に破棄\n' +
          '  - イベント目的達成後即時破棄\n' +
          '  - 不正利用会員記録は解約日から1年間保管\n\n' +
          '（d）収集方法\n' +
          '  - ホームページ、書面、ファックス、電話、掲示板、メール、イベント、クッキー・ログ収集ツール\n\n' +
          '第3条 個人情報の廃棄手続きおよび方法\n' +
          '（a）廃棄手続き：目的達成後、内部方針および法令に従い一定期間保存後廃棄\n' +
          '（b）廃棄方法：紙書類は裁断・焼却、電子ファイルは復元不可能な方式で削除\n\n' +
          '第4条 個人情報の共有・提供\n' +
          '原則として事前同意なしに外部提供は行いません。ただし、\n' +
          '  - 利用者が同意した場合\n' +
          '  - 料金精算、サービス違反、法令に基づく捜査機関の要求等には例外的に適用\n\n' +
          '第5条 処理の委託\n' +
          'サービス向上のため外部専門業者に委託し、委託契約書に法規遵守および責任負担を明示\n' +
          '  - 委託業務：クレジットカード・口座振替・SMS → Settlebank\n\n' +
          '第6条 利用者の権利\n' +
          '利用者および法定代理人はホームページから個人情報の照会・修正・削除・退会を請求可能\n\n' +
          '第7条 同意の撤回\n' +
          '会員登録等の同意は書面・電話・メールでの要請により即時処理\n\n' +
          '第8条 クッキーの運用\n' +
          'パーソナライズされたサービス提供のためにクッキーを使用。ブラウザの設定により許可・拒否が可能。拒否時は一部サービスの利用が制限されることがあります。\n\n' +
          '第9条 保護対策\n' +
          '  - パスワード保護、ウイルス対策、暗号アルゴリズム、侵入防止システムの適用\n' +
          '  - 担当者のアクセス制限および定期的な教育の実施\n\n' +
          '第10条 子供の情報保護\n' +
          '14歳未満は法定代理人の同意が必須\n\n' +
          '第11条 広告情報の送信\n' +
          '明示的な拒否意思がない限り広告送信禁止。送信時には「広告」と明記\n\n' +
          '第12条 責任者の連絡先\n' +
          '個人情報保護責任者：キム・ハクス（経営支援室）1577-0564 / kimhs@thekgolf.com\n' +
          '第13条 改定\n' +
          '施行日：2021年01月02日',

      refundText:
          '本規定は、株式会社Kゴルフおよび加盟店において利用期間または利用回数を定めて前払いされたコンテンツ利用権（例：月定額券、回数券、シーズン券など）について、消費者が返金を要求する場合に適用され、関連法令および公正取引委員会の消費者紛争解決基準、さらに業界の標準に準拠して運営されます。\n\n' +
          '第1条（返金理由および基準）\n' +
          '1. 消費者の責により返金を要求する場合\n' +
          '  1) 利用開始前:\n' +
          '    - 決済日から7日以内に返金を要求した場合：「電子商取引法」第17条および第18条第9項に基づき全額返金。違約金・手数料なし。\n' +
          '    - 7日経過後に返金を要求した場合：申込撤回権は消滅し、利用開始後の基準が適用されます。\n' +
          '  2) 利用開始後:\n' +
          '    - 使用した日数・回数に相当する金額（正規単価）を差し引いた残額を返金。\n' +
          '    - 残額から違約金（手数料）10％を控除して返金。\n\n' +
          '2. 事業者の責により返金を要求する場合\n' +
          '  1) 利用開始前：決済金額を全額返金。\n' +
          '  2) 利用開始後：未使用の残期間・回数に相当する金額を全額返金。手数料なし。\n\n' +
          '第2条（返金手続）\n' +
          '1. 書面申請またはカスタマーセンターへの申請受付。\n' +
          '2. 決済日基準で7日以内に申請した場合は即時全額返金。\n' +
          '3. 利用開始後の申請時は、使用分を差し引き、違約金10％を控除した後、7営業日以内に返金。\n' +
          '4. 加盟店→本社への伝達後、精算・返金手続き。\n\n' +
          '第3条（返金計算の例）\n' +
          '例：月定額券 100$・利用期間30日\n' +
          '  - 10日使用後に解約した場合\n' +
          '    · 使用金額: 10 × 3.3$ = 33$\n' +
          '    · 残額: 100 – 33 = 67$\n' +
          '    · 違約金10%:  6.7$\n' +
          '    · 返金金額: 60.3$ (約 60$)\n\n' +
          '第4条（お客様お問い合わせ先）\n' +
          '返金およびお問い合わせ：カスタマーセンター +82-1577-0564\n\n' +
          '第5条（法的根拠）\n' +
          '· 「電子商取引等における消費者保護に関する法律」第17条・第18条\n' +
          '· 同法施行令第21条\n' +
          '· 「消費者紛争解決基準」（公正取引委員会告示 第2023-14号）'
    },
    tournament: {
      list: {
        tournamentOpen: '大会開設',
        tournamentId: '大会番号',
        title: '大会名',
        tournamentType: '大会のタイプ',
        period: '期間',
        participantCount: '参加人数',
        courseCount: 'コース数',
        modify: '修正',
        etc: 'その他',
        expires01: '新しいトーナメントシステムは7月にアップデートされる予定です。 \nアップデート後は、トーナメントごとに最大 4 つのコースを選択できるようになります。',
        expires02: 'アップデート前に予定されていたトーナメントの場合は、終了日を 2024 年 9 月 15 日までに設定してください。',

        modifyPossibility: '修正可能',
        modifyImpossibility: '修正不可',
        listDelete: '削除',
        earlyTermination: '早期終了',
        awarding: '授賞',
        awardAnnouncement: '授賞発表',
        awardRecipientsView: '授賞履歴',

        statusFilter: {
          all: '全体',
          proceeding: '進行中',
          expected: '予定',
          end: '終了',
        },

        popup: {
          deleteTournamentConfirm: {
            text1: '選択した大会を削除しますか？',
            text2: '※削除された大会は復旧できません。',

            requestSuccess: '大会を削除しました。',
            requestFail: '大会の削除ができませんでした。 \nもう一度お試しください。',
          },
          earlyEndTournamentConfirm: {
            text1: '現在進行中の大会を今の時間にて終了しますか？',
            text2: '※大会を終了すると、これ以上大会の参加ができなくなります。',
            text3: 'ただし、現在大会に参加中のユーザーはそのまま大会を進行することができます。',

            requestSuccess: '大会を早期終了しました。',
            requestFail: '大会の早期終了ができませんでした。 \nもう一度お試しください。',
          },
        },
      },

      open: {
        tournamentTerm: '大会約款',
        acceptTerms: '利用約款に同意',

        participatingStoresSettingAlert: '参加店舗は最大10 個まで開設できます。',
        participatingStoresSetting: '参加店舗の設定',
        addParticipatingStore: '参加店舗を追加',
        country: '国',
        province: '都/道',
        city: '府/県/区',
        participatingStore: '参加店舗',

        basicSetting: '基本設定',
        tournamentTitle: '大会名',
        tournamentTitlePlaceholder: '大会名を入力してください。 （日本語20文字、英語40文字以内に入力してください）',
        tournamentTitleInvalidMessage: '大会名は 20 文字以内で入力してください。',
        tournamentIntroduce: '大会紹介',
        tournamentIntroducePlaceholder: '大会の紹介文を入力してください。 （日本語100文字、英文120文字以内）\n※入力しない場合、空欄で表示されます。',
        tournamentIntroduceInvalidMessage: '大会の紹介は100文字以内で入力してください。',
        tournamentSummary: '大会概要',
        tournamentParticipantTerms: '参加者利用約款',
        tournamentSummaryDefaultValue:
        'Kゴルフ大会 利用規約\n' +
            'Kゴルフ大会は、Kゴルフ本社、Kゴルフ店舗オーナー、またはオーナー会の代表が主催し、Kゴルフのプログラムと設備を利用して開催されるスクリーンゴルフ大会です。\n' +
            '\n' +
            '第1条: 参加資格\n' +
            '異常会員を除き、Kゴルフに正式に登録しているすべての会員が参加可能です。\n' +
            '異常会員および非会員は大会に参加することができますが、そのラウンドのすべての記録はランキングおよび集計、表彰の対象外となります。\n' +
            '（異常会員とは、不正なイベント参加により制裁または懲戒を受けた会員、またはこれに相当する判定を受けたアカウントを指します。）\n' +
            '\n' +
            '第2条: 参加方法\n' +
            '全国のKゴルフ店舗でログイン後、トーナメントモードに入り、大会リストから参加したい大会を選択してラウンドを行います。\n' +
            '店舗のラウンド料金以外に、追加の参加費は発生しません。\n' +
            '本人名義の1つのアカウントのみ参加可能です。他人のアカウントまたは複数のアカウントで参加した場合、すべての参加が無効となり、表彰対象から除外されます。\n' +
            '\n' +
            '第3条: 表彰規定\n' +
            '大会終了後、Kゴルフアプリを通じて最終順位を確認できます。大会規定に違反した場合、表彰の対象外となります。\n' +
            '（非会員および店舗オーナーは表彰対象外です。）\n' +
            '表彰条件は大会主催者によって異なり、告知された内容に従って表彰が行われます。大会の進行状況に応じて表彰内容が変更される場合があります。\n' +
            '会員の連絡先（電話番号、住所）が正確でない場合、主催者の判断により表彰が取り消されることがあります。\n' +
            '店舗が主催する大会の場合、本社Kゴルフは大会条件および表彰に関与せず、それに関する責任を負いません。\n' +
            '合算ランキングで同点者が発生した場合、ラウンド数、バックカウント、最後のラウンド開始時刻の順に順位を決定します。\n' +
            'ただし、複数コースの場合、バックカウント計算はコースランキングに登録されたラウンドの合計スコアで算出します。\n' +
            '\n' +
            '第4条: 大会規定\n' +
            'ログインしている場合、ラウンド終了後にスコアカードの提出および順位は自動的に処理されます。\n' +
            '18ホールを完走したラウンドのみ認められます。未完了のラウンド記録はランキングおよび表彰から除外されます。\n' +
            'カメラを通じて本人確認ができない場合、失格となります。\n' +
            'ラウンドのルールはKゴルフプログラムに従い、基本条件や途中棄権などは主催者によって決定されます。\n' +
            'プログラム上の問題や天災などの理由で、事前告知された店舗大会が中止されたり、進行中の大会が中断されることがあります。\n' +
            'サービス上の問題ではなく、店舗の状況（ネットワーク不安定、停電など）による問題が発生した場合、その責任と解決は主催者と参加者で協議します。\n' +
            'やむを得ない状況で問題を解決するため、指定されたマリガン数を使用できます。問題がない場合でも本人の意思で使用できます。\n' +
            '本人のクラブを使用することができ、主催者は本人確認のために映像を確認することがあります。不正が発覚した場合、失格となります。また、コンピュータ操作による不正も失格処理されます。\n' +
            '参加者は事前に告知された大会条件を必ず理解し、違反した場合は失格となることがあります。\n' +
            '\n' +
            '第5条: 追加規定\n' +
            '主催者の指示に従わない場合や不履行があった場合、大会への参加が制限されることがあります。\n' +
            '大会終了後、いかなる問題提起も認められないことを原則とします。\n' +
            'システムエラーを理由に参加者が問題提起を行った場合、ログを確認して認定可否を決定します。\n' +
            '大会期間中に保存された動画は表彰審査用として使用され、一定期間後に削除されます。',
        tournamentThumbnail: '大会サムネイル',

        participationTarget: '参加対象',
        participationTargetDescription: '性別と年齢関係なく参加できます',
        addParticipationTarget: '参加対象の追加',
        participationTargetLimitType: '制限の区分',
        participationTargetName: '区分名',
        participationTargetFullName: '参加対象の区分名',
        participationTargetGender: '性別',
        participationTargetBirthYearLimit: '生年月日制限',
        participationTargetType: '参加対象のタイプ',
        participationTargetMinimumBirthYear: '最小生年月日',
        participationTargetMaximumBirthYear: '最大生年月日',
        participationTargetBirthYearMessage1: '開始年より前の年は選択できません。',
        participationTargetBirthYearMessage2: '終了年より後の年は選択できません。',
        participationTargetTeeBoxTypeSetting: 'ティーの位置設定',

        participationGrade: '参加等級',

        participationConditions: '参加条件',
        participationConditionsDescription: '既存のチャット履歴と関係なくすべて参加可能',
        addParticipationConditions: '参加条件を追加',
        participationConditionsLimitType: '制限の区分',
        participationConditionsTournamentList: '大会リスト',
        participationConditionsRankingsLitmit: 'ランキングの制限',
        participationConditionType: '参加条件のタイプ',
        participationConditionsTournamentTitlePlaceholder: '大会を検索してください。',

        participationPeriod: '参加期間',

        participatePublic: '参加手順',
        participatePublicPlaceholder: 'パスワード(4桁の数字)',

        public: '公開',
        nondisclosure: '非公開',

        courseSetting: 'コース設定',
        courseCount: 'コース数',
        courseCountUnit: '個',
        courseSelection: 'コース選択',
        courseNumber: 'No',
        courseTitle: 'コース名',
        courseType: 'コースタイプ',
        courseDifficulty: 'コース難易度',
        greenDifficulty: 'グリーン難易度',
        longestHole: 'ロングギストホール',
        nearpinHole: 'ニアピンホール',
        newPerio: 'シンペリオ',
        outCourseHole: '前半ホール',
        inCourseHole: '後半ホール',

        gameSetting: '競技の設定',
        difficultyEasy: '簡単',
        difficultyNormal: '通常',
        difficultyHard: '難しい',
        difficultyManual: '手動',
        courseStartOrder: 'コース開始順番',
        courseStartValue1: '前半ホール>後半ホール',
        courseStartValue2: '後半ホール>前半ホール',
        userDifficulty: 'ユーザー難易度',
        swingPlate: 'スイングプレート',
        mulliganCount: 'マリガン数',
        windPower: '風の強さ',
        holeCupPosition: 'ホールカップ位置',
        greenPosition: 'グリーン位置',
        concede: 'コンシード',
        greenSpeed: 'グリーン速さ',
        puttingLineCount: 'パッティングライン回数',
        greenHardness : 'グリーン硬度',
        teeBox: 'ティー位置',
        guideDistance: '目标距离',

        participantHandicap: '参加者ハンディキャップ',
        calibrationGrade: '等級別の補正',
        userGrade: '会員等級',
        scoreCorrection: 'スコアの補正',
        calibrationParticipant: '参加者別の補正',

        rankingCriteria: 'ランキング基準',
        rankingCriteriaDescription1: 'ランキング基準設定とは?',
        rankingCriteriaDescription2: '同位打数が複数の場合、その同位打数のランキング順を決める基準を設定することを意味します。',
        rankingCriteriaOne: '1位',
        rankingCriteriaGameRoundCount: 'ゲーム記録が多い順',
        rankingCriteriaGameRoundCountButton: 'ゲーム記録が多い順とは？',
        rankingCriteriaGameRoundCountDescription: 'スコアが同点の場合は、18 ホールをより多くラウンドしたプレーヤーが上位にランクされます。',
        rankingCriteriaTwo: '2位',
        rankingCriteriaOrderByGameRoundDesc: 'バックカウント計算',
        rankingCriteriaCountbackDescription: '大会の各コースで登録されたラウンドの9ホール合計、6ホール合計、3ホール合計、最後のホール合計の順にバックカウントを計算します。 このバックカウント計算は合算ランキングにのみ適用されます。',
        rankingCriteriaThree: '3位',
        rankingCriteriaBackCount: 'バックカウント方式の使用',
        rankingCriteriaBackCountButton: 'バックカウント方式とは?',
        rankingCriteriaLastRoundStartTime: '最終ラウンド開始時間',
        rankingCriteriaLastRoundStartTimeDescription: 'スコアと戦績が同じ場合は、18ホールを終了した最終ラウンドの開始時刻から最も新しい選手を上位として登録する。',
        rankingCriteriaUse: '使用',
        rankingCriteriaUnused: '未使用',

        awardSetting: '授賞設定',
        addAward: '授賞履歴を追加',
        awardName: '授賞名',
        awardNamePlaceholder: '授賞名を入力してください。',
        awardGender: '性別区分',
        awardGenderAll: '区分なし',
        awardItem: '授賞項目',
        awardType: '授賞タイプ',
        awardCourse: 'コース区分',
        awardCourseTotal: 'コース総合',
        awardRankingType: 'ランク区分',
        awardSingleRanking: 'シングルランク',
        awardRanegeRanking: '範囲ランキング',
        awardRankingRange: 'ランク範囲',
        awardRankingPlaceholder: 'ランキングを入力してください。',
        awardRankingRangeText1: 'から',
        awardRankingRangeText2: 'まで',
        awardProduct: '授賞賞品',
        awardProductPlaceholder: '賞品を入力してください。.',

        whetherLimit: '制限可否',
        unLimit: '制限なし',
        delete: '削除',
        all: '全体',
        yearUnit: '年',
        yearRangeText1: 'から',
        yearRangeText2: 'まで',

        save: '保存',
        modify: '修正',

        navigation: {
          step1: '利用約款の同意',
          step2: '大会の設定',
          step3: '大会開設',
        },

        popup: {
          courseSelection: {
            title: '大会コースの選択',
            courseSearch: 'コースの検索',
            courseSearchPlaceholder: 'コースを検索してください。',
            selection: '選択',
            save: '保存',
            cancel: '閉じる',

            message1: 'これ以上のコースは選択できません。',
            message2: 'コースを選択してください.',
          },
          rankingCriteriaGameRoundCount: {
            text1: '開催された大会に参加し、そのコースを完走した記録が多いユーザーを上位ランキングに登録する機能',
            cancel: '閉じる',
          },
          rankingCriteriaBackCount: {
            text1: 'ユーザーのスコアを前半ホール/後半ホールに分ける。',
            text2: '※先に打った9ホールが前半ホール、後の9ホールが後半ホールと分けられます。',
            text3: 'ホール番号が10ホールであっても後半ホールにはなりません。',
            text4: '後半ホールの総スコアが高いユーザーのランキングが上位に表示されます。',
            text5: '- 最後のホールから前の9ホール',
            text6: '後半（6ホール）のスコアが高いユーザーのランキングが上位に表示されます。',
            text7: '- 最後のホールから前の6ホール',
            text8: '後半（3ホール）のスコアが高いユーザーのランキングが上位に表示されます。',
            text9: '- 最後のホールから前の3ホール',
            text10: '最後のホールのスコアをそれぞれ比較し、スコアが高いユーザーのランキングが上位に表示されます。',
            cancel: '閉じる',
          },
          shopTournamentOpenConfirm: {
            text1: '作成した内容で大会を開設しますか？',
            text2: '開設された大会は大会リストで照会および修正が可能です。',

            title: 'すでに使用中の大会名です。 別の大会名を入力してください。',

            requestSuccess: '店舗大会の開設が完了しました。',
            requestFail: '店舗大会の開設中にエラーが発生しました。\nしばらくしてからもう一度お試しください。',
          },
          shopTournamentModifyConfirm: {
            text1: '作成した内容で更新しますか？',

            title: 'すでに使用中の大会名です。 別の大会名を入力してください。',

            requestSuccess: '店舗大会の修正が完了しました。',
            requestFail: '店舗大会の修正中にエラーが発生しました。\nしばらくしてからもう一度お試しください。',
          },
        },

        alert: {
          message1: '参加対象は少なくとも一人以上を入力してください。',
          message2: 'ハンディキャップは-99から99までのみ入力可能です。',
          message3: '大会開始時間は、24時間以降で入力してください。',
          message4: '大会期間は最大1年まで設定可能です。',
          message5: 'コース設定が空欄です。コース設定に内容を記入してください。',
          message6: '授賞設定が空欄です。 授賞設定に内容を記入してください。',
          message7: '開始ランキングを減らしてください。',
          message8: 'パスワードは4桁の数字のみ入力してください。',
          message9: '設定したランクにエラーがあります。 確認お願いします。\n例: -1, 0 のような数字は入力できません。',
          message10: '賞の名前を入力してください。',
          message11: '大会名を入力してください。',
          message12: '追加した授賞履歴の授賞項目を設定お願いいたします。',
          message13: 'コース数を確認してコースを選択してください',
        },

        isParticipationGrade: '等級使用の可否',
        participationGradeText1:
          '等級使用時 <img src="/images/icon/ui_icon_grade_0_0.png" alt="grade" class="icon_grade" /> <img src="/images/icon/ui_icon_grade_1_0.png" alt="grade" class= "icon_grade" />等級会員は大会に参加できません。',
        participationGradeSelectTitle: '参加対象',
        participationGradeSelectNoUse: '制限なし',
        participationGrade2: 'ブロンズ',
        participationGrade3: 'シルバー',
        participationGrade4: 'ゴールド',
        participationGrade5: 'プラチナ',
        participationGrade6: 'ダイヤモンド',
        participationKHandiText6: '-0.1 以下 (アンダーユーザー)',
        participationKHandiText5: '0.0以上〜+7.9以下（シングルユーザー）',
        participationKHandiText4: '+8.0以上〜+17.9以下（80ユーザー）',
        participationKHandiText3: '+18.0 以上 27.9 以下 (90 ユーザー)',
        participationKHandiText2: '+28.0以上〜（100打以上のユーザー）',
        participationGradeText6_3: 'Diamond 評価全体の 10% 以下',
        participationGradeText6_2: 'Diamond 評価全体が 10%上～30% 以下',
        participationGradeText6_1: 'Diamond 評価全体の 30%上～',
        participationGradeText5_3: 'ハンディ0.0以上〜2.0以下',
        participationGradeText5_2: 'ハンディ2.1以上〜5.0以下',
        participationGradeText5_1: 'ハンディ5.1以上〜7.9以下',
        participationGradeText4_3: 'ハンディ8.0以上〜10.0以下',
        participationGradeText4_2: 'ハンディ10.1以上〜14.0以下',
        participationGradeText4_1: 'ハンディ14.1以上〜17.9以下',
        participationGradeText3_3: 'ハンディ18.0以上〜20.0以下',
        participationGradeText3_2: 'ハンディ20.1以上〜24.0以下',
        participationGradeText3_1: 'ハンディ24.1以上〜27.9以下',
        participationGradeText2_3: 'ハンディ28.0以上〜38.0以下',
        participationGradeText2_2: '「ンディ38.1以上〜48.0以下',
        participationGradeText2_1: 'ハンディ48.1以上〜',
        calibration: '補正値',
        kHandi: 'K Handi',
        criteria: '基準',
        notAllowed: '参加不可',
      },

      details: {
        tab: {
          summary: '大会概要',
          information: '大会情報',
          ranking: '大会ランキング',
          award: '大会賞',
          awardHistory: '授賞履歴',
          participantTerms: '参加者利用約款',
          participatingStoresList: '参加店舗リスト',
        },

        information: {
          introduce: '大会紹介',

          tournamentPeriod: '大会期間',
          participatePublic:'参加方法',

          participationTarget: '参加対象',
          participationNoLimit: '制限なし',
          participationTargetName: '区分名',
          participationTargetFullName: '参加対象区分名',
          participationTargetMinimumBirthYear: '最小生年',
          participationTargetMaximumBirthYear: '最大生年',
          participationTargetTeeBoxSetting: 'ティー位置の設定',

          participationGrade: '参加等級',
          gradeParticipationAvailability: '参加可否',
          participationPossible: '参加可能',
          unableParticipate: '参加不可',

          participationConditions: '参加条件',
          participationConditionTournamentName: '大会名',
          participationConditionRankingLimit: 'ランキングの制限',

          tournamentCourse: '大会コース',
          courseNumber: 'コース番号',
          courseName: 'コース名',
          courseLongest: 'ロングギスト',
          courseNearpin: 'ニアピン',
          sinperioExclusionHall: 'シンペリオ除外ホール',

          userDifficulty: 'ユーザーの難易度',
          swingPlate: 'スイングプレート',
          mulliganCount: 'マリガン数',
          windPower: '風強さ',
          holeCupPosition: 'ホールカップ位置',
          greenPosition: 'グリーン位置',
          concede: 'コンシード',
          greenSpeed: 'グリーン速さ',
          puttingLineCount: 'パッティングライン数',
          teeBox: 'ティー位置',
          greenHardness: 'グリーン硬度',
          calibrationGrade: '等級別補正',
          guideDistance: '目标距离',

          calibrationParticipant: '参加対象別補正',

          awardItem: '授賞項目',
          awardName: '授賞名',
          awardType: '授賞タイプ',
          awardCourse: 'コースの区分',
          awardRankingType: 'ランキングの区分',
          awardSingleRanking: 'シングルランキング',
          awardRanegeRanking: '範囲ランキング',
          awardRankingRange: 'ランキング範囲',
          awardRankingUnit: '等',
          awardProduct: '授賞賞品',
          awardNone: 'なし',
          awardAll: '全体',

          awardAnnouncement: '受賞者の発表',
          scoreCorrection: 'スコア補正',
          genderNoLimit: '無関係',
          participationGradeTitle: '参加対象および補正情報',
        },

        participatingStoresList: {
          country: '国',
          province: '都/道',
          city: '府/県/区',
          participatingStore: '参加店舗',
          all: '全体',
        },

        ranking: {
          courseTotalScore: 'スコア合計',
          searchTextBoxPlaceholder: 'ニックネームを入力してください。',

          allRanking: '全体ランキング',
          allRankingOption1: 'ランキングの高い順',
          allRankingOption2: 'ランキングの低い順',
          allRankingOptionReset: '初期化',

          genderRanking: '性別ランキング',
          genderRankingOption1: '女性のみ',
          genderRankingOption2: '男性のみ',
          genderRankingOptionAll: '全体',

          nickname: 'ニックネーム',
          participationCount: '参加回数',
          teeBoxLocation: 'ティーボックス位置',
          totalDistance: '飛距離 (m)',
          remainDistance: '残りの距離 (m)',
          recordTime: '最終ラウンド開始時間',
          lastRoundStartTime: 'Last Round Start Time',
          newPerioScoreRecord: '12ホール成績',
          finalScore: '最終スコア',
          birdieCount: 'バーディー回数',
          eagleCount: 'イーグル回数',
          courseName: 'コース名',
          holeNumber: 'ホール番号',
          courseDistance: '全長距離',
          totalParticipationCount: '総参加数',
          gradeRankingOption1: '高い順',
          gradeRankingOption2: '低い順',
          handicap: 'ハンディキャップ',
        },

        awardRanking: {
          allChoice: '全体選択',
          awardConfirmation: '授賞確定',
          resetAwards: '授賞初期化',
          awardRecipientsSelection: '受賞者選定',

          courseScore: 'コーススコア',
          handicap: 'ハンディキャップ',
          additionalHandicap: '追加のハンディキャップ',
          adjustmentResult: '調整結果',
          adjustmentSynthesis: '調整合計',
          finalScore: '最終スコア',
          courseOverall: 'コース合計',
          swingVideo: 'スイング映像',
          videoPlay: 'ビデオ再生',

          alert: {
            message1: '追加のハンディキャップは-99から99までの数字のみ入力してください。',
          },
        },

        awardHistory: {
          rankingUnit: '位',

          ranking: 'ランキング',
          nickname: 'ニックネーム',
          record: '記録',
          recordTime: '達成時間',
          totalParticipationCount: '総参加数',
          courseName: 'コース名',
          holeNumber: 'ホール番号',
        },

        course: 'コース',
        summation: '合計',
        gender: '性別',
        grade: '参加時の等級',
        startGrade: 'スタート·グレード',
        lastGrade: 'ファイナル·グレード',
        handicapGrade: 'グレード',
        storeUse: '利用店舗',
        public: '公開',
        nondisclosure: '非公開',

        alert: {
          message1: '大会終了後24時間経過してからアクセス可能',
          message2: '授賞履歴の確認は大会受賞者選定後に可能です。',
        },

        popup: {
          resetTournamentAwardsConfirm: {
            text1: '授賞の初期化を行いますか？',
            text2: '授賞の初期化を行うと、現在登録されている追加ハンディキャップと授賞確定履歴全てが初期化されます。',

            requestSuccess: '授賞履歴すべてを初期化しました。',
            requestFail: '授賞履歴の初期化に失敗しました。 \nもう一度お試しください。',
          },

          tournamentAwardRecipientsSelectionConfirm: {
            text1: '現在登録されている授賞確定に基づき受賞者を選定しますか？',
            text2: '登録された内容は授賞履歴ページから確認できます。',
            text3: '受賞者が発表された後は、ランキングを変更することはできません。',
            text4: 'ランキングを変更するには、調整を行う前に「賞品の初期化」を行う必要があります。',

            requestSuccess: '受賞者の選定が完了しました。 \n受賞者は授賞履歴ページから確認できます。',
            requestFail: '受賞者の選定が失敗しました。 \nもう一度お試しください。 ',
          },

          tournamentAwardAnnouncementConfirm: {
            text1: '受賞者を発表するとこれ以上受賞者の修正ができなくなります。',
            text2: '受賞者の発表を行いますか？',

            requestSuccess: '受賞者の発表が完了しました。',
            requestFail: '受賞者の発表に失敗しました。',
          },
        },
      },

      awardItem: {
        Score: 'スコア',
        Longest: 'ロングギスト',
        Nearpin: 'ニアピン',
        HoleInOne: 'ホールインワン',
        CourseRoundPlayCount: 'ラウンディング回数',
      },
      awardType: {
        Stroke: 'ストローク',
        NewPerio: 'シンペリオ',
        BirdieCount: 'バーディー回数',
        EagleCount: 'イーグル回数',
      },
    },
    control: {
      image: {
        delete: '削除',
        fileSelect: 'ファイル選択',
      },
    },
    contentsItem: {
      info: {
        prevItem: '購入リスト情報',
        prevItemText: '購入できない利用券です。 <br/>購入をご希望の場合はカスタマセンターまでお問い合わせください。',
        itemText: 'この商品は購入すると自動的に適用されます。',
        alertMsgTitle: 'コンテンツの使用ガイド',
        alertMsgSubTitle: '使用中のコンテンツ',
        alertMsgUser: 'こんにちは。 {user}さん。 ',
        paymentMsg: '購入したコンテンツの利用券は次のように適用されました。',
        paymentTitle: 'お支払い方法の選択',
      },
      button: {
        payment: '購入ページへ',
        purchase: '購入',
        rePurchase: '再購入',
        creditCard: 'クレジットカード',
        cash: '口座振込',
        paypal: 'PayPal',
      },
      shopSupplyItem: {
        salesCode:'材料コード'
      },
      1010110110: {
        title: 'コンテンツ利用券(期間制)',
        icon: '/itemImage/ui_icon_period.png',
        unit: 'DAYS',
        itemInfo: '店舗の機器',
        itemDescription: '{count}日間にゲームコンテンツが使用できるコンテンツ利用券（期間制）です。',
        itemPayment: '{count} 日が追加され、{newCount} 日間コンテンツが利用できます。',
        alertMsg: '店舗で使用中のコンテンツ利用券（期間制）が{count}日後に消尽予定です。円満なコンテンツ使用のためにコンテンツ利用券（期間制）を購入してください。',
        alertMsgNone: '使用中のコンテンツ利用券（期間制）がすべて消尽されました。\nコンテンツ利用券（期間制）が持ってない場合、新しいゲームに進めることはできません。\nShopにアクセスしコンテンツ利用券（期間制）を購入してください。',
      },
      1010120110: {
        title: 'コンテンツ利用券(ホール)',
        icon: '/itemImage/ui_icon_round.png',
        unit: 'HOLE',
        itemDescription: '{count}ホールが利用できるコンテンツ利用券（ホール）です。',
        itemPayment: '{count}ホールが追加され、{newCount}ホールが利用可能です。',
        alertMsg: '使用中のコンテンツ利用券（ホール）が{count}ホール残りました。円満な利用のためにはコンテンツ利用券（ホール）を購入してください。',
        alertMsgNone: '使用中のコンテンツ利用券（ホール）が{count}ホール残りました。\nコンテンツ利用券(ホール)が{round}ホール以下になると新しいゲームに進行できなくなります。\nShopにアクセスしコンテンツ利用券（ホール）を購入してください。',
      },
      alertMsg: {
        all: '使用中のコンテンツ利用券（期間制）が{day}日、コンテンツ利用券（ホール）が{count}ホールプレイ後に消尽されます。円満なプレーのためにはコンテンツ利用券（期間制）、コンテンツ利用券（ ホール）を購入してください。',
        allNone: '使用中のコンテンツ利用券(期間制)が{day}日、コンテンツ利用券(ホール)が{round}ホール以下になりました。\nコンテンツの利用券がない場合、新しいゲームに進めることはできません。\nShopにアクセスしコンテンツ利用券を購入してください。',
      },
      51101511111011: {
        title: 'Mat BGS Type Stance Mat',
        icon: '/itemImage/KGFMAT001012.jpg',
        unit: 'ea',
        itemDescription: 'ラバーベース付きスタンスマットが付属、サイズ 1100x1300mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode:'100061',
      },
      51101511111012: {
        title: 'Mat BGS Type (Left/Right) Fairway Mat Set',
        icon: '/itemImage/KGFMAT001013.jpg',
        unit: 'set',
        itemDescription: 'フェアウェイ、ラフ、バンカー、ラバーベースのオールインワンマットセット、600×1300mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100062',
      },
      51101511111013: {
        title: 'Mat BGS Type Cut-Out Fairway Mat',
        icon: '/itemImage/KGFMAT002015.jpg',
        unit: 'ea',
        itemDescription: 'ラフとバンカー用の切り抜き加工が施されたフェアウェイマット、底面はマジックテープ、サイズは600×1300mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100081',
      },
      51101511111014: {
        title: 'Mat BGS Type Fairway Mat',
        icon: '/itemImage/KGFMAT002016.jpg',
        unit: 'ea',
        itemDescription: 'フェアウェイマット、トップとツートンカラーの芝、サイズは370×1300mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100082',
      },
      51101511111015: {
        title: 'Mat BGS Type Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: 'バンカーとラフ用の切り抜き加工が施されたラバーベース、サイズは600×1300mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100073',
      },
      51101511111016: {
        title: 'Mat BGS Type Rough Mat',
        icon: '/itemImage/KGFMAT002001.jpg',
        unit: 'ea',
        itemDescription: 'ラフマット、底面はマジックテープ、サイズは400×230mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100067',
      },
      51101511111017: {
        title: 'Mat BGS Type Grey Bunker Mat',
        icon: '/itemImage/KGFMAT002017.jpg',
        unit: 'ea',
        itemDescription: 'グレーバンカーマット、底面はマジックテープ、サイズは400×230mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100083',
      },
      51101511111018: {
        title: 'Mat BGS Type Silver Brush Bunker Mat',
        icon: '/itemImage/KGFMAT001011.jpg',
        unit: 'ea',
        itemDescription: 'シルバーブラッシュバンカーマット、スチール底面にマジックテープ、サイズは400×230mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100060',
      },
      51101512111011: {
        title: 'Mat KDR Type Stance Mat',
        icon: '/itemImage/KGFMAT001015.jpg',
        unit: 'ea',
        itemDescription: 'スタンスマット、ラバーベース、サイズは1000×1000mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100064',
      },
      51101512111012: {
        title: 'Mat KDR Type Fairway Mat',
        icon: '/itemImage/KGFMAT001017.jpg',
        unit: 'ea',
        itemDescription: 'フェアウェイマット、ラバーベース、ツートンカラーの芝、サイズは500×1000mm。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100066',
      },
      51101513111011: {
        title: 'Auto Tee Type  Auto Tee up System',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: 'フロアキーパッド一体型自動ティーアップシステムセット付属。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100175',
      },
      51101514111012: {
        title: 'Consumables Type Rubber Tee',
        icon: '/itemImage/100187.jpg',
        unit: 'ea',
        itemDescription: 'ラバーティー（JE）<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100187',
      },
      51101514111013: {
        title: 'Consumables Type Rubber Tee (Moving Swing Plate)',
        icon: '/itemImage/100188.jpg',
        unit: 'ea',
        itemDescription: 'スイングプレート用ラバーティー。JEオートティーアップシステムに対応。<br />* お支払い管理メニューで注文のステータスを確認できます。',
        salesCode: '100188',
      },
      51101517700001: {
        title: 'Mat BGS Type Fairway Mat',
        icon: '/itemImage/700001.jpg',
        unit: 'ea',
        itemDescription: 'ツートンカラーの芝のフェアウェイマット、底はベルクロ、サイズは 370 x 1040 mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '700001',
      },
      51101517700002: {
        title: 'Mat BGS Type Fairway Extension Mat 1',
        icon: '/itemImage/700002.jpg',
        unit: 'ea',
        itemDescription: 'フェアウェイマット用延長パネル。底面はマジックテープ式。230×240mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '700002',
      },
      51101517700003: {
        title: 'Mat BGS Type Fairway Extension Mat 2',
        icon: '/itemImage/700003.jpg',
        unit: 'ea',
        itemDescription: 'フェアウェイマット用延長パネル。底面はマジックテープ式。260×600mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '700003',
      },
      51101517700004: {
        title: 'Mat BGS Type Fairway Mat Rubber base',
        icon: '/itemImage/700004.jpg',
        unit: 'ea',
        itemDescription: 'フェアウェイセット用ラバーベース、表面はマジックテープ式、サイズ：600×1300mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '700004',
      },
      51101517700005: {
        title: 'Mat BGS Type Rough Mat',
        icon: '/itemImage/700005.jpg',
        unit: 'ea',
        itemDescription: 'ラフマット（底面はマジックテープ式）、サイズ：400×230mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '700005',
      },
      51101517700007: {
        title: 'Mat BGS Type Stance Mat',
        icon: '/itemImage/700007.jpg',
        unit: 'ea',
        itemDescription: 'スタンスマット（底面はゴム製）、サイズ：1100×1300mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '700007',
      },
      51101517700009: {
        title: 'Mat BGS Type Fairway Set (Right Hand)',
        icon: '/itemImage/700009.jpg',
        unit: 'ea',
        itemDescription: '右利き用オールインワンマットセット（フェアウェイ、ラフ、バンカー、ラバーベース付き）、600×1300mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '700009',
      },
      51101517700010: {
        title: 'Mat BGS Type Fairway Set (Left Hand)',
        icon: '/itemImage/700010.jpg',
        unit: 'ea',
        itemDescription: '左利き用オールインワンマットセット（フェアウェイ、ラフ、バンカー、ラバーベース付き）、600×1300mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '700010',
      },
      51101517100175: {
        title: 'Auto Tee Type Auto Tee up System(Right Hand)',
        icon: '/itemImage/100175.jpg',
        unit: 'ea',
        itemDescription: '右利き用、自動ティーアップシステム内蔵。フロアキーパッド付き。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '100175',
      },
      51101517100176: {
        title: 'Auto Tee Type Auto Tee up System (Left Hand)',
        icon: '/itemImage/100176.jpg',
        unit: 'ea',
        itemDescription: '左利き用、自動ティーアップシステム内蔵。フロアキーパッド付き。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '100176',
      },
      51101517100222: {
        title: 'Mat BGS Type Bunker Mat',
        icon: '/itemImage/100222.jpg',
        unit: 'ea',
        itemDescription: 'スチール製の底面にマジックテープで留めるブラッシュバンカーマット。サイズ：400×230mm。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '100222',
      },
      51101514111011: {
        title: 'Consumables Type Rubber Tee',
        icon: '/itemImage/100186.jpg',
        unit: 'ea',
        itemDescription: 'ラバーティー（CT&G）<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '100186',
      },
      51101514111014: {
        title: 'Consumables Type Marking Golf Balls',
        icon: '/itemImage/KGFBAL001001.jpg',
        unit: 'box',
        itemDescription: '4ドットパターンのマーキング付き。1箱に300個のボールが入っています。<br />* ご注文状況はお支払い管理メニューでご確認いただけます。',
        salesCode: '100166',
      },

    },
  },
};
